import React, { useState, useEffect } from 'react';
import SEO from '../../components/SEO/SEO';
import './RedCuidaPage.css';

const RedCuidaPage = ({ darkMode }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [showForm, setShowForm] = useState(false);
  
  // Frases motivacionales para mostrar aleatoriamente
  const motivationalPhrases = [
    "Gracias por cuidar con corazón cada día.",
    "Hoy también haces que el mundo sea un lugar más humano.",
    "Pequeños cuidados, grandes diferencias.",
    "Cada día que empiezas aquí, alguien empieza a sentirse mejor.",
    "Tu esfuerzo diario construye bienestar en los demás.",
    "Cada acción tuya mejora la vida de alguien más.",
    "Gracias por estar, por cuidar y por seguir sumando humanidad.",
    "Hoy tus manos y tu tiempo volverán a marcar la diferencia.",
    "Porque cuando cuidas, el mundo se vuelve un poco más amable.",
    "Tu presencia es la parte más importante del cuidado.",
    "Tu trabajo tiene más impacto del que imaginas.",
    "Lo que haces cada día deja una huella silenciosa pero profunda.",
    "Cuidar también es una forma de dejar huella.",
    "Tu vocación da sentido a cada día de quienes te rodean.",
    "A veces el mejor remedio es tu compañía.",
    "El cuidado empieza con una sonrisa, y tú traes muchas.",
    "Tu labor no se mide en horas, sino en bienestar.",
    "El valor de lo que haces no cabe en una pantalla.",
    "Gracias por ser parte del cambio que se nota, aunque a veces no se vea.",
    "Cada persona a la que ayudas deja un poco de su historia en ti."
  ];

  // Seleccionar una frase aleatoria al cargar la página
  const [randomPhrase] = useState(() => {
    return motivationalPhrases[Math.floor(Math.random() * motivationalPhrases.length)];
  });

  // Actualizar la hora cada segundo para mantenerla actualizada
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  return (
    <div className={`redcuida-page ${darkMode ? 'dark' : 'light'}`}>
      <SEO 
        title="RedCuida | E-ASY"
        description="Plataforma de gestión para servicios de cuidado y atención. RedCuida facilita la coordinación y el seguimiento de la atención domiciliaria."
        keywords="RedCuida, gestión cuidados, atención domiciliaria, servicios sociales, Canarias"
        canonical="https://e-asy.es/redcuida"
      />

      {/* Banner de entorno de pruebas */}
      <div className="test-environment-banner">
        🧪 ENTORNO DE PRUEBAS
      </div>

      {/* Fecha y hora en esquina superior derecha */}
      <div className="time-display">
        <div className="time-date">
          {currentTime.toLocaleDateString('es-ES', { 
            weekday: 'long', 
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
        </div>
        <div className="time-hour">
          {currentTime.toLocaleTimeString('es-ES', { 
            hour: '2-digit', 
            minute: '2-digit',
            second: '2-digit'
          })}
        </div>
      </div>

      {/* Contenido principal */}
      {!showForm ? (
        <div className="main-content">
          <h1 className="main-title">Bienvenido a RedCuida</h1>
          <p className="main-subtitle">Tu plataforma de gestión para servicios de cuidado</p>
          <p className="main-subtitle-secondary">{randomPhrase}</p>

          <div className="tips-container">
            <h2 className="tips-title">Información importante</h2>
            <div className="tips-list">
              <div className="tip-item">
                <div className="tip-icon">📋</div>
                <p className="tip-text">
                  Recuerda <strong>registrar todas las intervenciones</strong> realizadas durante tu jornada para mantener un seguimiento adecuado.
                </p>
              </div>
              <div className="tip-item">
                <div className="tip-icon">🔔</div>
                <p className="tip-text">
                  Revisa las <strong>notificaciones pendientes</strong> al inicio de tu turno para estar al día con los cambios y novedades.
                </p>
              </div>
              <div className="tip-item">
                <div className="tip-icon">📱</div>
                <p className="tip-text">
                  Puedes acceder a RedCuida desde cualquier <strong>dispositivo móvil</strong> para registrar información en tiempo real.
                </p>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <button className="support-button" onClick={toggleForm}>
              Abrir Soporte
            </button>
          </div>
        </div>
      ) : (
        <div className="form-content">
          <div className="form-header">
            <h2 className="form-title">Formulario de Soporte</h2>
            <p className="form-subtitle">
              Completa el formulario con los detalles de tu consulta. Nuestro equipo te responderá lo antes posible.
            </p>
          </div>

          <div className="hubspot-form-container">
            <iframe 
              src="https://share-eu1.hsforms.com/1n-Wy2taSR8ml-XuJJrFlgAfbhti"
              width="100%"
              height="700"
              frameBorder="0"
              title="Formulario de Soporte Técnico RedCuida"
              style={{ border: 'none', borderRadius: '12px' }}
            ></iframe>
          </div>

          <div className="back-section">
            <button className="back-button" onClick={toggleForm}>
              Volver
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RedCuidaPage;

